// extracted by mini-css-extract-plugin
module.exports = {"SearchResult":"SearchResult_SearchResult__12Gq2","checkboxInput":"SearchResult_checkboxInput__30VO6","checkedLabel":"SearchResult_checkedLabel__Exz9Y"};